module.exports = __webpack_public_path__ + "static/media/dash-menu-icon.61be61b1.svg";